module.exports = __webpack_public_path__ + "img/logo-agrovision.95351b0b.svg";